import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';

interface CalendarProps {
    value?: Dayjs | null;
    onChange?: (date: Dayjs | null) => void;
}

export const Calendar: React.FC<CalendarProps> = ({ value, onChange }) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
            <DateCalendar value={value} onChange={onChange} sx={{ borderRadius: '5px', width:'100%'}} disablePast/>
        </LocalizationProvider>
    );
}